// request.js

import axios from 'axios';

const instance = axios.create({
  // baseURL: 'https://businessbg.czsgaf.com/',
  // baseURL: 'https://cwshop.scxssss.com/',
  // baseURL: 'https://cwshop.tmmbuy.com/',
  // baseURL: 'https://admin2.51sioc.com/',
  baseURL: "https://ht.wteam.club/api",
  // baseURL: "https://ht.shop110.cn/api",//广德安防

  // baseURL: "https://thjbusiness.wteam.club/api",
  // baseURL: "https://sxght.wteam.club/api",
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    "storeId": localStorage.getItem("storeId") != null ? localStorage.getItem("storeId") : ""
  },
});

//收银机图片接口
const instance2 = axios.create({
  // baseURL: "https://cwshop.tmmbuy.com/device",
  // baseURL: 'https://admin2.51sioc.com/',·
  baseURL: "https://ht.wteam.club/device",
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    "storeId": localStorage.getItem("storeId")
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // 假设你的 token 存储在本地存储中

    // 如果有 token，将其添加到请求头
    if (token) {
      config.headers['token'] = `${token}`;
      config.headers['storeId'] = localStorage.getItem("storeId") ? localStorage.getItem("storeId") : ""
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 收银机接口添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // 假设你的 token 存储在本地存储中

    // 如果有 token，将其添加到请求头
    if (token) {
      config.headers['token'] = `${token}`;
      config.headers['storeId'] = localStorage.getItem("storeId") ? localStorage.getItem("storeId") : ""

    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function get(url, params = {}) {
  return instance
    .get(url, {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export function post(url, data = {}) {
  return instance
    .post(url, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}




// WEBPACK FOOTER //
// ./src/api/request.js